export default "__VITE_ASSET__1b135ecb__"